@import '../../../../constants/spacing.module.less';

.items-section-header-content {
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: @space-8;
}

.group-by-field {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.group-by-dropdown {
  font-size: 12px;
  line-height: 16px;
  height: 16px;
  min-height: 16px;
  gap: @space-4;
}
